import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";

const Home = () => {
  useEffect(() => {
    // Smooth scroll handler for anchor links
    const handleSmoothScroll = (e) => {
      const anchor = e.target.closest('a[href^="#"]');
      if (anchor) {
        const targetId = anchor.getAttribute('href');
        if (targetId && targetId !== '#' && targetId.length > 1) {
          const targetElement = document.querySelector(targetId);
          if (targetElement) {
            e.preventDefault();
            targetElement.scrollIntoView({
              behavior: 'smooth'
            });
          }
        }
      }
    };

    document.addEventListener('click', handleSmoothScroll);

    return () => {
      document.removeEventListener('click', handleSmoothScroll);
    };
  }, []);

  return (
    <React.Fragment>
      <Header name={{ name: "Advantis Express", group: "home" }} />
      
      <div className="text-gray-800 bg-white flex flex-col" style={{ fontFamily: "'Inter', sans-serif" }}>
        <style>{`
          html {
            scroll-snap-type: y mandatory;
            scroll-behavior: smooth;
            height: 100vh;
            overflow-y: scroll;
            scroll-padding-top: 100px;
          }
          section, footer {
            scroll-snap-align: start;
            scroll-snap-stop: always;
            scroll-margin-top: 100px;
          }
        `}</style>

      {/* Hero Section (Full Page) */}
      <section id="hero" className="relative min-h-screen flex flex-col justify-center overflow-hidden" style={{
        backgroundImage: 'url(/assets/img/banner.png)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      }}>
        {/* Dark Overlay */}
        <div className="absolute inset-0 bg-brand-navy/30 z-0"></div>

        <div className="container mx-auto px-8 md:px-12 relative z-10 flex flex-col items-center text-center">
          <div className="max-w-4xl mx-auto">
            <span className="inline-block py-1 px-3 rounded-full bg-brand-blue/10 text-brand-accent text-sm font-semibold mb-6 border border-brand-accent/30">
              Exclusive Licensee in Sri Lanka
            </span>
            <h1 className="text-4xl md:text-6xl font-bold text-white mb-6 leading-tight">
              Connecting Sri Lanka <br/><span className="block mt-4">to the World</span>
            </h1>
            <p className="text-white text-lg mb-8 max-w-2xl mx-auto">
              As the authorised Global Service Provider, Advantis International Express combines local expertise with a world-class global network to deliver on your promises.
            </p>
            
            <div className="bg-white p-6 rounded-lg shadow-xl max-w-md border-t-4 border-brand-accent mx-auto text-left">
              <h3 className="text-brand-navy font-bold mb-4 flex items-center justify-center md:justify-start">
                <i className="fas fa-search-location mr-2 text-brand-blue"></i> Track Your Shipment
              </h3>
              <p className="text-sm text-gray-500 mb-4 text-center md:text-left">You will be re-directed to fedex.com for tracking services</p>
              <div className="flex gap-2">
                <a 
                  href="https://www.fedex.com/en-lk/home.html" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="w-full bg-brand-navy hover:bg-brand-blue text-white font-semibold py-3 px-4 rounded transition text-center flex items-center justify-center gap-2 shadow-lg"
                >
                  Go to FedEx Tracking <i className="fas fa-external-link-alt text-xs"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
        
        {/* Scroll Indicator */}
        <div className="absolute bottom-10 left-1/2 transform -translate-x-1/2 text-white/50 animate-bounce">
          <i className="fas fa-chevron-down text-2xl"></i>
        </div>
      </section>

      {/* About Section (Full Page) */}
      <section id="about" className="min-h-screen flex flex-col justify-center bg-white py-16">
        <div className="container mx-auto px-8 md:px-12">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl font-bold text-brand-navy mb-6">Your Local Partner for Global Logistics</h2>
              <p className="text-gray-600 mb-4 leading-relaxed">
                Advantis Express Pvt Ltd is at the forefront of international shipping and logistics solutions in Sri Lanka. With deep local expertise and access to a extensive global network, we provide unmatched express delivery services tailored to your needs.
              </p>
              <p className="text-gray-600 mb-6 leading-relaxed">
                Our mission is to empower businesses and individuals in Sri Lanka by offering seamless, efficient, and secure courier services. At Advantis - International
                Express, we don't just deliver parcels we deliver peace of mind.
              </p>
              <div className="flex gap-8 mt-8 border-t pt-8">
                <div>
                  <span className="block text-3xl font-bold text-brand-blue">1350+</span>
                  <span className="text-sm text-gray-500">Active Clients</span>
                </div>
                <div>
                  <span className="block text-3xl font-bold text-brand-blue">5</span>
                  <span className="text-sm text-gray-500">BOI Zones</span>
                </div>
              </div>
            </div>
            <div className="bg-brand-light rounded-2xl p-8 h-96 md:h-full flex items-center justify-center relative overflow-hidden">
              <div className="absolute inset-0 bg-brand-navy opacity-[0.03]"></div>
              <div className="text-center relative z-10">
                <i className="fas fa-handshake text-6xl text-brand-navy mb-4 opacity-80"></i>
                <h3 className="text-xl font-bold text-brand-navy">Trusted Partnership</h3>
                <p className="text-gray-500 mt-2 text-sm">Providing service excellence in Sri Lanka <br/> since 2025.</p>
                </div>
              </div>
            </div>
          </div>
        </section>

      {/* Services Section (Full Page) */}
      <section id="services" className="min-h-screen flex flex-col justify-center bg-brand-light py-16">
        <div className="container mx-auto px-8 md:px-12">
          <div className="text-center mb-12">
            <span className="text-brand-blue font-bold tracking-wider uppercase text-sm">Our Expertise</span>
            <h2 className="text-3xl font-bold text-brand-navy mt-2">Comprehensive Shipping Solutions</h2>
              </div>

          <div className="grid md:grid-cols-3 gap-8">
            {/* Service 1 */}
            <div className="bg-white p-8 rounded-xl shadow-sm hover:shadow-xl transition group border-t-2 border-transparent hover:border-brand-accent">
              <div className="w-12 h-12 bg-blue-50 rounded-full flex items-center justify-center text-brand-blue mb-6 group-hover:bg-brand-navy group-hover:text-white transition">
                <i className="fas fa-plane-departure text-xl"></i>
              </div>
              <h3 className="text-xl font-bold text-brand-navy mb-3">International Priority</h3>
              <p className="text-gray-600 text-sm mb-4">Fast, reliable, and secure delivery of documents and parcels to over 220 countries and territories worldwide.</p>
              <a href="https://www.fedex.com/en-lk/home.html" className="text-brand-blue font-semibold text-sm hover:underline hover:text-brand-navy transition">Check Rates &rarr;</a>
            </div>

            {/* Service 2 */}
            <div className="bg-white p-8 rounded-xl shadow-sm hover:shadow-xl transition group border-t-2 border-transparent hover:border-brand-accent">
              <div className="w-12 h-12 bg-blue-50 rounded-full flex items-center justify-center text-brand-blue mb-6 group-hover:bg-brand-navy group-hover:text-white transition">
                <i className="fas fa-box-open text-xl"></i>
              </div>
              <h3 className="text-xl font-bold text-brand-navy mb-3">Heavy Weight Services</h3>
              <p className="text-gray-600 text-sm mb-4">Comprehensive air freight solutions tailored for heavy or bulk shipments, ensuring safe logistics and timely delivery.</p>
              <a href="https://www.fedex.com/en-lk/home.html" className="text-brand-blue font-semibold text-sm hover:underline hover:text-brand-navy transition">Learn More &rarr;</a>
                  </div>

            {/* Service 3 */}
            <div className="bg-white p-8 rounded-xl shadow-sm hover:shadow-xl transition group border-t-2 border-transparent hover:border-brand-accent">
              <div className="w-12 h-12 bg-blue-50 rounded-full flex items-center justify-center text-brand-blue mb-6 group-hover:bg-brand-navy group-hover:text-white transition">
                <i className="fas fa-file-contract text-xl"></i>
                </div>
              <h3 className="text-xl font-bold text-brand-navy mb-3">Customs Clearance</h3>
              <p className="text-gray-600 text-sm mb-4">Expert handling of customs procedures and paperwork to guarantee smooth import and export processes.</p>
              <Link to="/customer-support" className="text-brand-blue font-semibold text-sm hover:underline hover:text-brand-navy transition">Contact Us &rarr;</Link>
              </div>
            </div>
          </div>
        </section>

      {/* Global Reach Section (Full Page) */}
      <section id="global" className="min-h-screen flex flex-col justify-center bg-brand-navy text-white relative">
        <div className="absolute inset-0 z-0 opacity-20 bg-[url('https://www.fedex.com/content/dam/fedex/us-united-states/shipping/images/2021/Q2/FedEx_Airplane_1920x1080.jpg')] bg-cover bg-center"></div>
        <div className="absolute inset-0 bg-brand-navy/90 z-0"></div>

        <div className="container mx-auto px-8 md:px-12 relative z-10 text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-6 text-white">Powered by a Global Network</h2>
          <p className="text-xl text-white max-w-2xl mx-auto mb-10">
            Through our partnership, we bring the world's largest express transportation company right to your doorstep in Sri Lanka.
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <a 
              href="https://www.fedex.com/en-lk/home.html" 
              target="_blank"
              rel="noopener noreferrer"
              className="bg-brand-accent text-brand-navy font-bold py-3 px-8 rounded hover:bg-white hover:text-brand-navy transition shadow-lg"
            >
              Ship Now on FedEx.com
            </a>
            <Link to="/contact-us" className="bg-transparent border border-white text-white font-bold py-3 px-8 rounded hover:bg-white/10 transition">
              Find a Drop-off Location
            </Link>
              </div>
          <p className="mt-6 text-xs text-white">
            *You will be redirected to the official FedEx website for shipping transactions.
          </p>
          </div>
        </section>

      </div>
      
      <Footer />
    </React.Fragment>
  );
};

export default Home;
